export enum DrawingTool {
  pencil = "PENCIL",
  point = "POINT",
  line = "LINE",
  clear = "CLR",
  returnBack = "RETURN_BACK",
  empty = "EMPTY",
  answerPoint = "ANSWER_POINT",
  answerLine = "ANSWER_LINE",
  ruler = "RULER",
  protractor = "PROTRACTOR",
  compass = "COMPASS"
}

export enum ShapeType {
  square = "SQUARE",
  rectangle = "RECTANGLE",
  t = "T_SHAPE",
  l = "L_SHAPE",
  parallel = "PARALLELOGRAM",
  triangle = "TRIANGLE",
  rightTriangle = "RIGHT_TRIANGLE",
  trapezoid = "TRAPEZOID",
  rightTrapezoid = "RIGHT_TRAPEZOID",
}

export enum ShapeColor {
  black = 0x000000,
  red = 0xFF0000
}

export enum QuestionType {
  TYPE1 = "TYPE1",
  TYPE2 = "TYPE2"
}

export enum QuestionMode {
  test = "TEST",
  practise = "PRACTISE"
}

export enum Direction {
  clockwise = "clockwise",
  antiClockwise = "anti-clockwise"
}